import { configureStore } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import api from './api'
import youtubeReady from './youtubeReady'
import modal from './modal'

const isDev = process.env.NODE_ENV === 'development'

const sharredMiddleware = [api.middleware]

const middleware = isDev ? [...sharredMiddleware, logger] : sharredMiddleware

const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    youtubeReady,
    modal
  },
  middleware: getDefault => getDefault().concat(middleware)
})

export default store
